// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/exportdata/v1/exportdata.proto" (package "c1.api.exportdata.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../../../../google/protobuf/timestamp";
import { TSDBMetricServiceGetTopValuesRequest } from "../../tsdb/v1/tsdb";
import { SearchGrantsExpiringBeforeRequest } from "../../app/v1/app_entitlement";
import { ListOpenExtensionTicketsRequest } from "../../task/v1/search";
import { AccessReviewSearchServiceGetProgressByAppRequest } from "../../accessreview/v1/accessreview_search";
import { AccessReviewSearchServiceCountOpenReviewsByUserRequest } from "../../accessreview/v1/accessreview_search";
import { AccessReviewSearchServiceGetReviewerDecisionsRequest } from "../../accessreview/v1/accessreview_search";
import { SubmissionsDownloadRequest } from "../../accessreview/v1/accessreview_pending";
import { SearchAppEntitlementsWithRevokableForAppUserRequest } from "../../app/v1/app_entitlement";
import { SearchUsageResourcesRequest } from "../../usage_event/v1/usage_event";
import { SearchGrantFeedRequest } from "../../app/v1/app_entitlement_user_binding";
import { SearchUsersRequest } from "../../user/v1/user";
import { AccessProfileMembershipRequest } from "../../requestcatalog/v1/requestcatalog";
import { SearchAppEntitlementsWithExpiredRequest } from "../../app/v1/app_entitlement";
import { ValidateScopeRequest } from "../../accessreview/v1/accessreview";
import { TaskSearchRequest } from "../../task/v1/search";
import { UsersWithUnspecifiedEmploymentStatusRequest } from "../../user/v1/user";
import { SearchPastGrantsRequest } from "../../app/v1/app_entitlement_user_binding";
import { AccessViolationSearchRequest } from "../../accessconflict/v1/accessviolation";
import { SearchAppsWithDeactivatedOwnerRequest } from "../../app/v1/app";
import { UsersWithoutManagerRequest } from "../../user/v1/user";
import { SearchAppUsersWithStandingHighRiskGrantsRequest } from "../../app/v1/app_entitlement_user_binding";
import { HighRiskRolesAndGrantsEntitlementsRequest } from "../../app/v1/app_resource";
import { SearchAppResourcesWithDeactivatedOwnerRequest } from "../../app/v1/app_resource";
import { SearchAppResourceRollupRequest } from "../../app/v1/app_resource";
import { SearchAppEntitlementsWithDeactivatedOwnerRequest } from "../../app/v1/app_entitlement";
import { SearchAppEntitlementsWithOneOwnerRequest } from "../../app/v1/app_entitlement";
import { SearchAppsExpandedRequest } from "../../app/v1/app";
import { SearchInactiveUsersRequest } from "../../app/v1/app_usage";
import { HighRiskUsersAndGrantsRequest } from "../../app/v1/app_user";
import { SearchOrphanedAccountsRequest } from "../../app/v1/app_user";
import { AppUsersWithoutResponsiblePartyRequest } from "../../app/v1/app_user";
import { AppUserServiceSearchRequest } from "../../app/v1/app_user";
/**
 * @generated from protobuf message c1.api.exportdata.v1.ExportDataRequest
 */
export interface ExportDataRequest {
    /**
     * @generated from protobuf field: c1.api.exportdata.v1.QueryId query_id = 1;
     */
    queryId: QueryId;
    /**
     * @generated from protobuf oneof: request
     */
    request: {
        oneofKind: "appUserServiceSearchRequest";
        /**
         * @generated from protobuf field: c1.api.app.v1.AppUserServiceSearchRequest app_user_service_search_request = 100;
         */
        appUserServiceSearchRequest: AppUserServiceSearchRequest;
    } | {
        oneofKind: "appUsersWithoutResponsiblePartyRequest";
        /**
         * @generated from protobuf field: c1.api.app.v1.AppUsersWithoutResponsiblePartyRequest app_users_without_responsible_party_request = 101;
         */
        appUsersWithoutResponsiblePartyRequest: AppUsersWithoutResponsiblePartyRequest;
    } | {
        oneofKind: "searchOrphanedAccountsRequest";
        /**
         * @generated from protobuf field: c1.api.app.v1.SearchOrphanedAccountsRequest search_orphaned_accounts_request = 102;
         */
        searchOrphanedAccountsRequest: SearchOrphanedAccountsRequest;
    } | {
        oneofKind: "highRiskRolesAndGrantsRequest";
        /**
         * @generated from protobuf field: c1.api.app.v1.HighRiskUsersAndGrantsRequest high_risk_roles_and_grants_request = 103;
         */
        highRiskRolesAndGrantsRequest: HighRiskUsersAndGrantsRequest;
    } | {
        oneofKind: "searchInactiveAppUsersRequest";
        /**
         * @generated from protobuf field: c1.api.app.v1.SearchInactiveUsersRequest search_inactive_app_users_request = 104;
         */
        searchInactiveAppUsersRequest: SearchInactiveUsersRequest;
    } | {
        oneofKind: "searchAppsExpandedRequest";
        /**
         * @generated from protobuf field: c1.api.app.v1.SearchAppsExpandedRequest search_apps_expanded_request = 105;
         */
        searchAppsExpandedRequest: SearchAppsExpandedRequest;
    } | {
        oneofKind: "searchAppEntitlementsWithOneOwnerRequest";
        /**
         * @generated from protobuf field: c1.api.app.v1.SearchAppEntitlementsWithOneOwnerRequest search_app_entitlements_with_one_owner_request = 106;
         */
        searchAppEntitlementsWithOneOwnerRequest: SearchAppEntitlementsWithOneOwnerRequest;
    } | {
        oneofKind: "searchAppEntitlementsWithDeactivatedOwnerRequest";
        /**
         * @generated from protobuf field: c1.api.app.v1.SearchAppEntitlementsWithDeactivatedOwnerRequest search_app_entitlements_with_deactivated_owner_request = 107;
         */
        searchAppEntitlementsWithDeactivatedOwnerRequest: SearchAppEntitlementsWithDeactivatedOwnerRequest;
    } | {
        oneofKind: "searchAppResourceRollupRequest";
        /**
         * @generated from protobuf field: c1.api.app.v1.SearchAppResourceRollupRequest search_app_resource_rollup_request = 108;
         */
        searchAppResourceRollupRequest: SearchAppResourceRollupRequest;
    } | {
        oneofKind: "searchAppResourcesWithDeactivatedOwnerRequest";
        /**
         * @generated from protobuf field: c1.api.app.v1.SearchAppResourcesWithDeactivatedOwnerRequest search_app_resources_with_deactivated_owner_request = 109;
         */
        searchAppResourcesWithDeactivatedOwnerRequest: SearchAppResourcesWithDeactivatedOwnerRequest;
    } | {
        oneofKind: "highRiskRolesAndGrantsEntitlementsRequest";
        /**
         * @generated from protobuf field: c1.api.app.v1.HighRiskRolesAndGrantsEntitlementsRequest high_risk_roles_and_grants_entitlements_request = 110;
         */
        highRiskRolesAndGrantsEntitlementsRequest: HighRiskRolesAndGrantsEntitlementsRequest;
    } | {
        oneofKind: "searchAppUsersWithStandingHighRiskGrantsRequest";
        /**
         * @generated from protobuf field: c1.api.app.v1.SearchAppUsersWithStandingHighRiskGrantsRequest search_app_users_with_standing_high_risk_grants_request = 111;
         */
        searchAppUsersWithStandingHighRiskGrantsRequest: SearchAppUsersWithStandingHighRiskGrantsRequest;
    } | {
        oneofKind: "usersWithoutManagerRequest";
        /**
         * @generated from protobuf field: c1.api.user.v1.UsersWithoutManagerRequest users_without_manager_request = 112;
         */
        usersWithoutManagerRequest: UsersWithoutManagerRequest;
    } | {
        oneofKind: "searchAppsWithDeactivatedOwnerRequest";
        /**
         * @generated from protobuf field: c1.api.app.v1.SearchAppsWithDeactivatedOwnerRequest search_apps_with_deactivated_owner_request = 113;
         */
        searchAppsWithDeactivatedOwnerRequest: SearchAppsWithDeactivatedOwnerRequest;
    } | {
        oneofKind: "accessViolationSearchRequest";
        /**
         * @generated from protobuf field: c1.api.accessconflict.v1.AccessViolationSearchRequest access_violation_search_request = 114;
         */
        accessViolationSearchRequest: AccessViolationSearchRequest;
    } | {
        oneofKind: "searchPastGrantsRequest";
        /**
         * @generated from protobuf field: c1.api.app.v1.SearchPastGrantsRequest search_past_grants_request = 115;
         */
        searchPastGrantsRequest: SearchPastGrantsRequest;
    } | {
        oneofKind: "usersWithUnspecifiedEmploymentStatusRequest";
        /**
         * @generated from protobuf field: c1.api.user.v1.UsersWithUnspecifiedEmploymentStatusRequest users_with_unspecified_employment_status_request = 116;
         */
        usersWithUnspecifiedEmploymentStatusRequest: UsersWithUnspecifiedEmploymentStatusRequest;
    } | {
        oneofKind: "taskSearchRequest";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskSearchRequest task_search_request = 117;
         */
        taskSearchRequest: TaskSearchRequest;
    } | {
        oneofKind: "validateScopeRequest";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.ValidateScopeRequest validate_scope_request = 118;
         */
        validateScopeRequest: ValidateScopeRequest;
    } | {
        oneofKind: "searchAppEntitlementsWithExpiredRequest";
        /**
         * @generated from protobuf field: c1.api.app.v1.SearchAppEntitlementsWithExpiredRequest search_app_entitlements_with_expired_request = 119;
         */
        searchAppEntitlementsWithExpiredRequest: SearchAppEntitlementsWithExpiredRequest;
    } | {
        oneofKind: "accessProfileMembershipRequest";
        /**
         * @generated from protobuf field: c1.api.requestcatalog.v1.AccessProfileMembershipRequest access_profile_membership_request = 120;
         */
        accessProfileMembershipRequest: AccessProfileMembershipRequest;
    } | {
        oneofKind: "searchUsersRequest";
        /**
         * @generated from protobuf field: c1.api.user.v1.SearchUsersRequest search_users_request = 121;
         */
        searchUsersRequest: SearchUsersRequest;
    } | {
        oneofKind: "searchGrantFeedRequest";
        /**
         * @generated from protobuf field: c1.api.app.v1.SearchGrantFeedRequest search_grant_feed_request = 122;
         */
        searchGrantFeedRequest: SearchGrantFeedRequest;
    } | {
        oneofKind: "searchUsageResourcesRequest";
        /**
         * @generated from protobuf field: c1.api.usage_event.v1.SearchUsageResourcesRequest search_usage_resources_request = 123;
         */
        searchUsageResourcesRequest: SearchUsageResourcesRequest;
    } | {
        oneofKind: "searchAppEntitlementsWithRevokableForAppUserRequest";
        /**
         * @generated from protobuf field: c1.api.app.v1.SearchAppEntitlementsWithRevokableForAppUserRequest search_app_entitlements_with_revokable_for_app_user_request = 124;
         */
        searchAppEntitlementsWithRevokableForAppUserRequest: SearchAppEntitlementsWithRevokableForAppUserRequest;
    } | {
        oneofKind: "submissionsDownloadRequest";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.SubmissionsDownloadRequest submissions_download_request = 125;
         */
        submissionsDownloadRequest: SubmissionsDownloadRequest;
    } | {
        oneofKind: "campaignReviewerDecisionsRequest";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewSearchServiceGetReviewerDecisionsRequest campaign_reviewer_decisions_request = 126;
         */
        campaignReviewerDecisionsRequest: AccessReviewSearchServiceGetReviewerDecisionsRequest;
    } | {
        oneofKind: "campaignOpenReviewsByUserRequest";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewSearchServiceCountOpenReviewsByUserRequest campaign_open_reviews_by_user_request = 127;
         */
        campaignOpenReviewsByUserRequest: AccessReviewSearchServiceCountOpenReviewsByUserRequest;
    } | {
        oneofKind: "campaignProgressByAppRequest";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewSearchServiceGetProgressByAppRequest campaign_progress_by_app_request = 128;
         */
        campaignProgressByAppRequest: AccessReviewSearchServiceGetProgressByAppRequest;
    } | {
        oneofKind: "listOpenExtensionTicketsRequest";
        /**
         * @generated from protobuf field: c1.api.task.v1.ListOpenExtensionTicketsRequest list_open_extension_tickets_request = 129;
         */
        listOpenExtensionTicketsRequest: ListOpenExtensionTicketsRequest;
    } | {
        oneofKind: "searchGrantsExpiringBeforeRequest";
        /**
         * @generated from protobuf field: c1.api.app.v1.SearchGrantsExpiringBeforeRequest search_grants_expiring_before_request = 130;
         */
        searchGrantsExpiringBeforeRequest: SearchGrantsExpiringBeforeRequest;
    } | {
        oneofKind: "tsdbTopValuesRequest";
        /**
         * @generated from protobuf field: c1.api.tsdb.v1.TSDBMetricServiceGetTopValuesRequest tsdb_top_values_request = 131;
         */
        tsdbTopValuesRequest: TSDBMetricServiceGetTopValuesRequest;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: string display_name = 3;
     */
    displayName: string;
}
/**
 * @generated from protobuf message c1.api.exportdata.v1.ExportDataActionRef
 */
export interface ExportDataActionRef {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.exportdata.v1.ExportDataResponse
 */
export interface ExportDataResponse {
    /**
     * @generated from protobuf field: string export_data_action_id = 1;
     */
    exportDataActionId: string;
}
/**
 * @generated from protobuf message c1.api.exportdata.v1.ListExportDataRequest
 */
export interface ListExportDataRequest {
    /**
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: repeated c1.api.exportdata.v1.ExportDataActionRef refs = 4;
     */
    refs: ExportDataActionRef[];
}
/**
 * @generated from protobuf message c1.api.exportdata.v1.ExportDataAction
 */
export interface ExportDataAction {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: c1.api.exportdata.v1.ExportDataActionState state = 2;
     */
    state: ExportDataActionState;
    /**
     * @generated from protobuf field: string download_url = 3;
     */
    downloadUrl: string;
    /**
     * @generated from protobuf field: c1.api.exportdata.v1.QueryId query_id = 4;
     */
    queryId: QueryId;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 5;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: string display_name = 6;
     */
    displayName: string;
    /**
     * @generated from protobuf field: string file_name_pattern = 7;
     */
    fileNamePattern: string;
}
/**
 * @generated from protobuf message c1.api.exportdata.v1.ListExportDataResponse
 */
export interface ListExportDataResponse {
    /**
     * @generated from protobuf field: repeated c1.api.exportdata.v1.ExportDataAction list = 1;
     */
    list: ExportDataAction[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf enum c1.api.exportdata.v1.QueryId
 */
export enum QueryId {
    /**
     * @generated from protobuf enum value: QUERY_ID_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: QUERY_ID_APP_USERS_WITHOUT_OWNER = 1;
     */
    APP_USERS_WITHOUT_OWNER = 1,
    /**
     * @generated from protobuf enum value: QUERY_ID_ALL_APP_USERS = 2;
     */
    ALL_APP_USERS = 2,
    /**
     * @generated from protobuf enum value: QUERY_ID_RESOURCES = 3;
     */
    RESOURCES = 3,
    /**
     * @generated from protobuf enum value: QUERY_ID_HIGH_RISK_ROLE_GRANTS_PERMANENT = 4;
     */
    HIGH_RISK_ROLE_GRANTS_PERMANENT = 4,
    /**
     * @generated from protobuf enum value: QUERY_ID_HIGH_RISK_ROLE_GRANTS_TEMPORARY = 5;
     */
    HIGH_RISK_ROLE_GRANTS_TEMPORARY = 5,
    /**
     * @generated from protobuf enum value: QUERY_ID_APP_RESOURCES_WITH_DEACTIVATED_OWNER = 6;
     */
    APP_RESOURCES_WITH_DEACTIVATED_OWNER = 6,
    /**
     * @generated from protobuf enum value: QUERY_ID_USERS_WITHOUT_MANAGER = 7;
     */
    USERS_WITHOUT_MANAGER = 7,
    /**
     * @generated from protobuf enum value: QUERY_ID_APP_USERS_NOT_LOGGED_IN_RECENTLY = 8;
     */
    APP_USERS_NOT_LOGGED_IN_RECENTLY = 8,
    /**
     * @generated from protobuf enum value: QUERY_ID_ORPHANED_ACCOUNTS = 9;
     */
    ORPHANED_ACCOUNTS = 9,
    /**
     * @generated from protobuf enum value: QUERY_ID_APP_ENTITLEMENTS_WITH_ONE_OWNER = 10;
     */
    APP_ENTITLEMENTS_WITH_ONE_OWNER = 10,
    /**
     * @generated from protobuf enum value: QUERY_ID_HIGH_RISK_ACCOUNTS = 11;
     */
    HIGH_RISK_ACCOUNTS = 11,
    /**
     * @generated from protobuf enum value: QUERY_ID_STANDING_PRIVILEGES = 12;
     */
    STANDING_PRIVILEGES = 12,
    /**
     * @generated from protobuf enum value: QUERY_ID_APPS_WITH_ONE_OWNER = 13;
     */
    APPS_WITH_ONE_OWNER = 13,
    /**
     * @generated from protobuf enum value: QUERY_ID_APPS_WITH_DEACTIVATED_OWNERS = 14;
     */
    APPS_WITH_DEACTIVATED_OWNERS = 14,
    /**
     * @generated from protobuf enum value: QUERY_ID_APP_ENTITLEMENTS_WITH_DEACTIVATED_OWNER = 15;
     */
    APP_ENTITLEMENTS_WITH_DEACTIVATED_OWNER = 15,
    /**
     * @generated from protobuf enum value: QUERY_ID_PER_APP_ACCOUNTS = 16;
     */
    PER_APP_ACCOUNTS = 16,
    /**
     * @generated from protobuf enum value: QUERY_ID_ACCESS_VIOLATIONS = 17;
     */
    ACCESS_VIOLATIONS = 17,
    /**
     * @generated from protobuf enum value: QUERY_ID_PAST_GRANTS = 18;
     */
    PAST_GRANTS = 18,
    /**
     * @generated from protobuf enum value: QUERY_ID_USERS_WITH_UNSPECIFIED_EMPLOYMENT_STATUS = 19;
     */
    USERS_WITH_UNSPECIFIED_EMPLOYMENT_STATUS = 19,
    /**
     * @generated from protobuf enum value: QUERY_ID_TASK_SEARCH = 20;
     */
    TASK_SEARCH = 20,
    /**
     * @generated from protobuf enum value: QUERY_ID_VALIDATE_SCOPE = 21;
     */
    VALIDATE_SCOPE = 21,
    /**
     * @generated from protobuf enum value: QUERY_ID_ENTITLEMENT_GRANTS = 22;
     */
    ENTITLEMENT_GRANTS = 22,
    /**
     * @generated from protobuf enum value: QUERY_ID_ACCESS_PROFILE_MEMBERSHIP = 23;
     */
    ACCESS_PROFILE_MEMBERSHIP = 23,
    /**
     * @generated from protobuf enum value: QUERY_ID_USER_SEARCH = 24;
     */
    USER_SEARCH = 24,
    /**
     * @generated from protobuf enum value: QUERY_ID_GRANT_FEED = 25;
     */
    GRANT_FEED = 25,
    /**
     * @generated from protobuf enum value: QUERY_ID_SHADOW_APPS = 26;
     */
    SHADOW_APPS = 26,
    /**
     * @generated from protobuf enum value: QUERY_ID_APP_USER_GRANTS = 27;
     */
    APP_USER_GRANTS = 27,
    /**
     * @generated from protobuf enum value: QUERY_ID_ACTIVE_EXTERNAL_ACCOUNTS = 28;
     */
    ACTIVE_EXTERNAL_ACCOUNTS = 28,
    /**
     * @generated from protobuf enum value: QUERY_ID_SUBMISSIONS_DOWNLOAD = 29;
     */
    SUBMISSIONS_DOWNLOAD = 29,
    /**
     * @generated from protobuf enum value: QUERY_ID_CAMPAIGN_REVIEWER_DECISIONS = 30;
     */
    CAMPAIGN_REVIEWER_DECISIONS = 30,
    /**
     * @generated from protobuf enum value: QUERY_ID_CAMPAIGN_OPEN_REVIEWS_BY_USER = 31;
     */
    CAMPAIGN_OPEN_REVIEWS_BY_USER = 31,
    /**
     * @generated from protobuf enum value: QUERY_ID_CAMPAIGN_PROGRESS_BY_APP = 32;
     */
    CAMPAIGN_PROGRESS_BY_APP = 32,
    /**
     * @generated from protobuf enum value: QUERY_ID_OPEN_EXTENSION_TICKETS = 33;
     */
    OPEN_EXTENSION_TICKETS = 33,
    /**
     * @generated from protobuf enum value: QUERY_ID_EXPIRING_GRANTS = 34;
     */
    EXPIRING_GRANTS = 34,
    /**
     * @generated from protobuf enum value: QUERY_ID_TSDB_TOP_VALUES = 35;
     */
    TSDB_TOP_VALUES = 35
}
/**
 * @generated from protobuf enum c1.api.exportdata.v1.ExportDataActionState
 */
export enum ExportDataActionState {
    /**
     * @generated from protobuf enum value: EXPORT_DATA_ACTION_STATE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: EXPORT_DATA_ACTION_STATE_PENDING = 1;
     */
    PENDING = 1,
    /**
     * @generated from protobuf enum value: EXPORT_DATA_ACTION_STATE_READY = 2;
     */
    READY = 2,
    /**
     * @generated from protobuf enum value: EXPORT_DATA_ACTION_STATE_ERROR = 3;
     */
    ERROR = 3,
    /**
     * @generated from protobuf enum value: EXPORT_DATA_ACTION_STATE_DELETED = 4;
     */
    DELETED = 4,
    /**
     * @generated from protobuf enum value: EXPORT_DATA_ACTION_STATE_DELETION_ERROR = 5;
     */
    DELETION_ERROR = 5
}
// @generated message type with reflection information, may provide speed optimized methods
class ExportDataRequest$Type extends MessageType<ExportDataRequest> {
    constructor() {
        super("c1.api.exportdata.v1.ExportDataRequest", [
            { no: 1, name: "query_id", kind: "enum", T: () => ["c1.api.exportdata.v1.QueryId", QueryId, "QUERY_ID_"] },
            { no: 100, name: "app_user_service_search_request", kind: "message", oneof: "request", T: () => AppUserServiceSearchRequest },
            { no: 101, name: "app_users_without_responsible_party_request", kind: "message", oneof: "request", T: () => AppUsersWithoutResponsiblePartyRequest },
            { no: 102, name: "search_orphaned_accounts_request", kind: "message", oneof: "request", T: () => SearchOrphanedAccountsRequest },
            { no: 103, name: "high_risk_roles_and_grants_request", kind: "message", oneof: "request", T: () => HighRiskUsersAndGrantsRequest },
            { no: 104, name: "search_inactive_app_users_request", kind: "message", oneof: "request", T: () => SearchInactiveUsersRequest },
            { no: 105, name: "search_apps_expanded_request", kind: "message", oneof: "request", T: () => SearchAppsExpandedRequest },
            { no: 106, name: "search_app_entitlements_with_one_owner_request", kind: "message", oneof: "request", T: () => SearchAppEntitlementsWithOneOwnerRequest },
            { no: 107, name: "search_app_entitlements_with_deactivated_owner_request", kind: "message", oneof: "request", T: () => SearchAppEntitlementsWithDeactivatedOwnerRequest },
            { no: 108, name: "search_app_resource_rollup_request", kind: "message", oneof: "request", T: () => SearchAppResourceRollupRequest },
            { no: 109, name: "search_app_resources_with_deactivated_owner_request", kind: "message", oneof: "request", T: () => SearchAppResourcesWithDeactivatedOwnerRequest },
            { no: 110, name: "high_risk_roles_and_grants_entitlements_request", kind: "message", oneof: "request", T: () => HighRiskRolesAndGrantsEntitlementsRequest },
            { no: 111, name: "search_app_users_with_standing_high_risk_grants_request", kind: "message", oneof: "request", T: () => SearchAppUsersWithStandingHighRiskGrantsRequest },
            { no: 112, name: "users_without_manager_request", kind: "message", oneof: "request", T: () => UsersWithoutManagerRequest },
            { no: 113, name: "search_apps_with_deactivated_owner_request", kind: "message", oneof: "request", T: () => SearchAppsWithDeactivatedOwnerRequest },
            { no: 114, name: "access_violation_search_request", kind: "message", oneof: "request", T: () => AccessViolationSearchRequest },
            { no: 115, name: "search_past_grants_request", kind: "message", oneof: "request", T: () => SearchPastGrantsRequest },
            { no: 116, name: "users_with_unspecified_employment_status_request", kind: "message", oneof: "request", T: () => UsersWithUnspecifiedEmploymentStatusRequest },
            { no: 117, name: "task_search_request", kind: "message", oneof: "request", T: () => TaskSearchRequest },
            { no: 118, name: "validate_scope_request", kind: "message", oneof: "request", T: () => ValidateScopeRequest },
            { no: 119, name: "search_app_entitlements_with_expired_request", kind: "message", oneof: "request", T: () => SearchAppEntitlementsWithExpiredRequest },
            { no: 120, name: "access_profile_membership_request", kind: "message", oneof: "request", T: () => AccessProfileMembershipRequest },
            { no: 121, name: "search_users_request", kind: "message", oneof: "request", T: () => SearchUsersRequest },
            { no: 122, name: "search_grant_feed_request", kind: "message", oneof: "request", T: () => SearchGrantFeedRequest },
            { no: 123, name: "search_usage_resources_request", kind: "message", oneof: "request", T: () => SearchUsageResourcesRequest },
            { no: 124, name: "search_app_entitlements_with_revokable_for_app_user_request", kind: "message", oneof: "request", T: () => SearchAppEntitlementsWithRevokableForAppUserRequest },
            { no: 125, name: "submissions_download_request", kind: "message", oneof: "request", T: () => SubmissionsDownloadRequest },
            { no: 126, name: "campaign_reviewer_decisions_request", kind: "message", oneof: "request", T: () => AccessReviewSearchServiceGetReviewerDecisionsRequest },
            { no: 127, name: "campaign_open_reviews_by_user_request", kind: "message", oneof: "request", T: () => AccessReviewSearchServiceCountOpenReviewsByUserRequest },
            { no: 128, name: "campaign_progress_by_app_request", kind: "message", oneof: "request", T: () => AccessReviewSearchServiceGetProgressByAppRequest },
            { no: 129, name: "list_open_extension_tickets_request", kind: "message", oneof: "request", T: () => ListOpenExtensionTicketsRequest },
            { no: 130, name: "search_grants_expiring_before_request", kind: "message", oneof: "request", T: () => SearchGrantsExpiringBeforeRequest },
            { no: 131, name: "tsdb_top_values_request", kind: "message", oneof: "request", T: () => TSDBMetricServiceGetTopValuesRequest },
            { no: 3, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.exportdata.v1.ExportDataRequest
 */
export const ExportDataRequest = new ExportDataRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExportDataActionRef$Type extends MessageType<ExportDataActionRef> {
    constructor() {
        super("c1.api.exportdata.v1.ExportDataActionRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.exportdata.v1.ExportDataActionRef
 */
export const ExportDataActionRef = new ExportDataActionRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExportDataResponse$Type extends MessageType<ExportDataResponse> {
    constructor() {
        super("c1.api.exportdata.v1.ExportDataResponse", [
            { no: 1, name: "export_data_action_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.exportdata.v1.ExportDataResponse
 */
export const ExportDataResponse = new ExportDataResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListExportDataRequest$Type extends MessageType<ListExportDataRequest> {
    constructor() {
        super("c1.api.exportdata.v1.ListExportDataRequest", [
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ExportDataActionRef }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.exportdata.v1.ListExportDataRequest
 */
export const ListExportDataRequest = new ListExportDataRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExportDataAction$Type extends MessageType<ExportDataAction> {
    constructor() {
        super("c1.api.exportdata.v1.ExportDataAction", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "state", kind: "enum", T: () => ["c1.api.exportdata.v1.ExportDataActionState", ExportDataActionState, "EXPORT_DATA_ACTION_STATE_"] },
            { no: 3, name: "download_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "query_id", kind: "enum", T: () => ["c1.api.exportdata.v1.QueryId", QueryId, "QUERY_ID_"] },
            { no: 5, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "file_name_pattern", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.exportdata.v1.ExportDataAction
 */
export const ExportDataAction = new ExportDataAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListExportDataResponse$Type extends MessageType<ListExportDataResponse> {
    constructor() {
        super("c1.api.exportdata.v1.ListExportDataResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ExportDataAction },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.exportdata.v1.ListExportDataResponse
 */
export const ListExportDataResponse = new ListExportDataResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.exportdata.v1.ExportDataService
 */
export const ExportDataService = new ServiceType("c1.api.exportdata.v1.ExportDataService", [
    { name: "ExportData", options: { "authz.method": { role: "EDITOR" } }, I: ExportDataRequest, O: ExportDataResponse },
    { name: "List", options: { "authz.method": { role: "VIEWER" } }, I: ListExportDataRequest, O: ListExportDataResponse }
]);
